import styled from 'styled-components';

export const OdontogramContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 10px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin: 10px 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
`;

export const OdontogramaTitle = styled.h2`
  margin: 0 0 15px 0;
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
`;

export const ArcadaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  padding: 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
`;

export const ArcadaLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #34495e;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TeethRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  width: max-content;
  min-width: fit-content;
`;

export const ToothWrapper = styled.div`
  position: relative;
  flex: 0 0 auto;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  svg {
    display: block;
    cursor: pointer;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    transition: all 0.2s ease;
    border-radius: 4px;

    .dente {
      fill: #fff;
      stroke: #555;
      stroke-width: 0.5;
    }

    .ausente,
    .coroa,
    .endodoncia,
    .implante {
      fill: none;
      opacity: 0;
    }

    .marcadoAmarelo {
      fill: yellow;
      stroke: black;
      stroke-width: 1px;
    }

    .marcadoVermelho {
      fill: red;
      stroke: black;
      stroke-width: 1px;
    }

    .marcadoLaranja {
      fill: none;
      stroke: #ffa500;
      stroke-width: 4;
    }

    .marcadoTomate {
      fill: none;
      stroke: #ff6347;
      stroke-width: 2;
    }

    .marcadoMarrom {
      fill: #cc6600;
      stroke: black;
      stroke-width: 1px;
    }

    .marcadoRoxo {
      fill: #cc66cc;
      stroke: black;
      stroke-width: 0.5;
    }

    .marcadoVerde {
      fill: #00ff00;
      stroke: black;
      stroke-width: 1px;
    }

    .marcadoVerdeClaro {
      fill: #90ee90;
      stroke: black;
      stroke-width: 1px;
    }

    .marcadoAzul {
      fill: none;
      stroke: #0000ff;
      stroke-width: 4;
    }

    &:hover {
      filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
      background: rgba(255, 255, 255, 0.1);
    }

    polygon,
    circle {
      transition: all 0.2s ease;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;

export const Instructions = styled.div`
  font-size: 11px;
  color: #7f8c8d;
  text-align: center;
  margin-bottom: 10px;
  font-style: italic;
`;
